import type { Ref } from "vue";
import { computed } from "vue";

export default defineNuxtPlugin((nuxtApp) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const i18n = nuxtApp.$i18n as any;
    const dir = computed<"ltr" | "rtl">(() => {
        const raw = i18n?.locale?.value ?? i18n?.locale ?? "";
        const code = String(raw).trim().toLowerCase();
        return ["fa"].includes(code) ? "rtl" : "ltr";
    });

    nuxtApp.provide("dir", dir);
});

declare module "#app" {
    interface NuxtApp {
        $dir: Ref<"ltr" | "rtl">;
    }
}

declare module "vue" {
    interface ComponentCustomProperties {
        $dir: Ref<"ltr" | "rtl">;
    }
}

export {};
